import styled from 'styled-components';
export const Container = styled.div `
  margin-bottom: var(--space-400);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-brand);
`;
export const Header = styled.div `
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid var(--border-secondary);
  padding: var(--space-400) var(--space-500);
  background: var(--bg-secondary);
`;
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  align-self: center;
  flex: 1;
  gap: var(--space-200);

  &:empty {
    display: none;
  }
`;
export const Title = styled.div `
  color: var(--text-primary);

  font-family: var(--font-family-heading);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-dense);
`;
export const Subtitle = styled.div `
  color: var(--text-secondary);

  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
  letter-spacing: var(--font-letter-spacing-looser);
`;
export const Description = styled.div `
  color: var(--text-secondary);

  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
  letter-spacing: var(--font-letter-spacing-looser);
`;
